import { TurboMount } from "turbo-mount";
import { registerComponent } from "turbo-mount/react";

// import { Workbook } from "@fortune-sheet/react";
// import { DataEditor } from "@glideapps/glide-data-grid"

import ReactDataGridComponent from "../components/react/ReactDataGridComponent";


const turboMount = new TurboMount();

import "@glideapps/glide-data-grid/dist/index.css";
registerComponent(turboMount, "ReactDataGridComponent", ReactDataGridComponent);
